import { runDetached } from '@hprofits/utils';
import { useRoute, useRouter } from 'vue-router';

/**
 * Returns a `redirect` that navigates to the catch-all not-found route
 * (`Page404`, `src/router/routes/error.js`) while PRESERVING the attempted URL —
 * the address bar still shows the dead link instead of collapsing to `/`.
 *
 * Uses `replace` (not `push`) so the back button does not return to the missing
 * entity. Driven by the resolved page state, so a redirect issued during setup
 * is applied on the next navigation tick.
 */
export const useNotFoundRedirect = (): (() => void) => {
  const route = useRoute();
  const router = useRouter();

  return () => {
    runDetached(
      router.replace({
        name: 'Page404',
        params: { pathMatch: route.path.slice(1).split('/') },
      }),
    );
  };
};
